import { get } from 'lodash';

import * as HandoverApi from '@/api/handover';
import actionTypes from './actionType';

export const updateState = (state) => {
  return {
    type: actionTypes.UPDATE_REPORT_STATE,
    payload: state,
  };
};

// 交班报表页--常规业务
export const initHandoverBaseBusiness = () => {
  return async (dispatch) => {
    dispatch(updateState({ baseBusinessHandoverLoading: true }));
    try {
      const res = await HandoverApi.fetchHandoverBaseBusiness();
      if (res.code === 0) {
        const baseBusinessIncomeList = get(res, 'data.baseBusIncomeMsgDTO', {});
        let paymentTypeList = get(res, 'data.baseBusPaymentTypeMsgDTOS', {});
        paymentTypeList = paymentTypeList?.map((item) => ({
          ...item,
          total: item.income - item.refund,
        }));
        dispatch({
          type: actionTypes.HANDOVER_BAS_BUSINESS,
          payload: {
            baseBusinessIncomeList,
            paymentTypeList,
          },
        });
      }
      dispatch(updateState({ baseBusinessHandoverLoading: false }));
    } catch (err) {
      dispatch(updateState({ baseBusinessHandoverLoading: false }));
    }
  };
};

// 交班报表页--会员卡相关
export const initHandoverMemberCard = () => {
  return async (dispatch) => {
    dispatch(updateState({ memberCardHandoverLoading: true }));
    try {
      const res = await HandoverApi.fetchHandoverMemberCard();
      if (res.code === 0) {
        const memberCardSale = get(res, 'data.memberCardDTO', {});
        const memberCardRecharge = get(res, 'data.memberCardRechargeDTO', {});
        dispatch({
          type: actionTypes.HANDOVER_MEMBER_CARD,
          payload: {
            memberCardSale,
            memberCardRecharge,
          },
        });
      }
      dispatch(updateState({ memberCardHandoverLoading: false }));
    } catch (err) {
      dispatch(updateState({ memberCardHandoverLoading: false }));
    }
  };
};

const toggleHandoverModalVisible = (visible) => {
  return {
    type: actionTypes.TOGGLE_HANDOVER_MODAL_VISIBLE,
    payload: {
      modalVisible: visible,
    },
  };
};

const setHandoverInfoLoading = (loading) => {
  return {
    type: actionTypes.SET_HANDOVER_INFO_LOADING,
    payload: {
      handoverInfoLoading: loading,
    },
  };
};

const initHandoverInfo = () => {
  return async (dispatch) => {
    dispatch(setHandoverInfoLoading(true));
    try {
      const res = await HandoverApi.fetchHandoverInfo();
      dispatch(setHandoverInfoLoading(false));

      const info = get(res, 'data', {});
      let list = [];
      if (info.shiftHandoverVOList) {
        list = info.shiftHandoverVOList.map((item) => {
          return {
            ...item,
            total: item.income - item.refund,
          };
        });
      }
      dispatch({
        type: actionTypes.INIT_HANDOVER_INFO,
        payload: {
          handoverInfo: info,
        },
      });
      dispatch({
        type: actionTypes.INIT_HANDOVER_AMOUNT_LIST,
        payload: {
          amountList: list,
        },
      });
    } catch (err) {
      dispatch(setHandoverInfoLoading(false));
    }
  };
};

const resetHandoverInfo = () => {
  return {
    type: actionTypes.RESET_HANDOVER_INFO,
    payload: {},
  };
};

export { toggleHandoverModalVisible, initHandoverInfo, resetHandoverInfo };
